import { ImportEmailListPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/email-lists/import'].update({
        staticData: { title: { page: 'EmailLists.Import.PageHeading' } },
        component: authGuard(ImportEmailListPage, { isWhitelabel: true, canManageEmailLists: true })
    });
};
